import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "dialTitle" }, "¿Quieres dejar de publicar esta oferta laboral?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Si lo haces, ya no será visible para estudiantes ni graduados. No se borrará y podrás volver a publicarla cuando quieras.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, {
      isEditing: true,
      formOfferData: _ctx.content,
      modality: _ctx.formatModality,
      company: _ctx.formatCompany,
      hierarchy: _ctx.formatHierarchy,
      city: _ctx.formatCity,
      area: _ctx.formatArea,
      onHandleStatusChange: _ctx.handleStatusChange
    }, {
      default: _withCtx(({Component}) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }, 8, ["formOfferData", "modality", "company", "hierarchy", "city", "area", "onHandleStatusChange"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayModal = $event)),
      draggable: false,
      style: {width: '50vw'},
      modal: true
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-arrow-left",
          onClick: _ctx.closeModal,
          class: "p-button-rounded p-button-text p-button-plain"
        }, null, 8, ["onClick"]),
        _hoisted_2
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          onClick: _ctx.closeModal,
          class: "p-button-text"
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "back-saveChanges",
          label: "Aceptar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unPublish()))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}